exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-btn[data-v-58607ec4] {\n  margin-left: 40px !important;\n  background-color: #ffe800 !important;\n}\n", ""]);

// exports
